import axios from '../axios'

/*
 * 信息发布模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/sysInfo/save',
    method: 'post',
    data
  })
};

// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/sysInfo/delete',
    method: 'post',
    data
  })
};

// 列表
export const list = (data) => {
  return axios({
    url: '/sysInfo/list',
    method: 'post',
    data
  })
};

// 编辑,新增
export const edit = (data) => {
  return axios({
    url: '/sysInfo/edit',
    method: 'post',
    data
  })
};

// 查看
export const view = (data) => {
  return axios({
    url: '/sysInfo/view',
    method: 'post',
    data
  })
};

// 根据信息类型选择
export const selectInfoType = (data) => {
  return axios({
    url: '/sysInfo/select',
    method: 'post',
    data
  })
};




// WEBPACK FOOTER //
// ./src/http/moudules/info.js